export class Organization {
  public id: string;
  public name: string;
  public profileImageUrl: string;

  constructor({ id, name, profileImageUrl }: { id: string; name: string; profileImageUrl: string }) {
    this.id = id;
    this.name = name;
    this.profileImageUrl = profileImageUrl;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/domain/entity/Organization.ts